<template>
  <span class="text-nowrap">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                 fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                 stroke-linejoin="round" class="feather feather-plus mr-50"><line x1="12" y1="5" x2="12"
                                                                                                  y2="19"></line><line
      x1="5" y1="12" x2="19" y2="12"></line></svg> Add New {{ name }}</span>
</template>

<script>
export default {
  props: ['name'],

}
</script>

